/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/ERPAdminCostDivisionRuleFixedRule', 'model/ERPAdminCostDivisionRuleFromAccount', 'model/ERPAdminCostDivisionRuleLevel', 'model/ERPAdminCostDivisionRuleSourceFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./ERPAdminCostDivisionRuleFixedRule'), require('./ERPAdminCostDivisionRuleFromAccount'), require('./ERPAdminCostDivisionRuleLevel'), require('./ERPAdminCostDivisionRuleSourceFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPAdminCostDivisionRuleReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.ERPAdminCostDivisionRuleFixedRule, root.ForStractionServiceApi.ERPAdminCostDivisionRuleFromAccount, root.ForStractionServiceApi.ERPAdminCostDivisionRuleLevel, root.ForStractionServiceApi.ERPAdminCostDivisionRuleSourceFilter);
  }
}(this, function(ApiClient, CorporateStructureLink, ERPAdminCostDivisionRuleFixedRule, ERPAdminCostDivisionRuleFromAccount, ERPAdminCostDivisionRuleLevel, ERPAdminCostDivisionRuleSourceFilter) {
  'use strict';




  /**
   * The ERPAdminCostDivisionRuleReport model module.
   * @module model/ERPAdminCostDivisionRuleReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPAdminCostDivisionRuleReport</code>.
   * @alias module:model/ERPAdminCostDivisionRuleReport
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>ERPAdminCostDivisionRuleReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPAdminCostDivisionRuleReport} obj Optional instance to populate.
   * @return {module:model/ERPAdminCostDivisionRuleReport} The populated <code>ERPAdminCostDivisionRuleReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SourceFilter')) {
        obj['SourceFilter'] = ERPAdminCostDivisionRuleSourceFilter.constructFromObject(data['SourceFilter']);
      }
      if (data.hasOwnProperty('FromAccounts')) {
        obj['FromAccounts'] = ApiClient.convertToType(data['FromAccounts'], [ERPAdminCostDivisionRuleFromAccount]);
      }
      if (data.hasOwnProperty('FixedRules')) {
        obj['FixedRules'] = ApiClient.convertToType(data['FixedRules'], [ERPAdminCostDivisionRuleFixedRule]);
      }
      if (data.hasOwnProperty('Levels')) {
        obj['Levels'] = ApiClient.convertToType(data['Levels'], [ERPAdminCostDivisionRuleLevel]);
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('DivisionMethodTypeID')) {
        obj['DivisionMethodTypeID'] = ApiClient.convertToType(data['DivisionMethodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DivisionMethodAccountRange')) {
        obj['DivisionMethodAccountRange'] = ApiClient.convertToType(data['DivisionMethodAccountRange'], 'String');
      }
      if (data.hasOwnProperty('SourceTrackingLevelID')) {
        obj['SourceTrackingLevelID'] = ApiClient.convertToType(data['SourceTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('TargetAccountNumber')) {
        obj['TargetAccountNumber'] = ApiClient.convertToType(data['TargetAccountNumber'], 'Integer');
      }
      if (data.hasOwnProperty('ValidFromDate')) {
        obj['ValidFromDate'] = ApiClient.convertToType(data['ValidFromDate'], 'Date');
      }
      if (data.hasOwnProperty('ValidToDate')) {
        obj['ValidToDate'] = ApiClient.convertToType(data['ValidToDate'], 'Date');
      }
      if (data.hasOwnProperty('DivisionMethodIndicatorID')) {
        obj['DivisionMethodIndicatorID'] = ApiClient.convertToType(data['DivisionMethodIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('UsePreviousRule')) {
        obj['UsePreviousRule'] = ApiClient.convertToType(data['UsePreviousRule'], 'Boolean');
      }
      if (data.hasOwnProperty('UseBudgetAndForecastData')) {
        obj['UseBudgetAndForecastData'] = ApiClient.convertToType(data['UseBudgetAndForecastData'], 'Boolean');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/ERPAdminCostDivisionRuleSourceFilter} SourceFilter
   */
  exports.prototype['SourceFilter'] = undefined;
  /**
   * @member {Array.<module:model/ERPAdminCostDivisionRuleFromAccount>} FromAccounts
   */
  exports.prototype['FromAccounts'] = undefined;
  /**
   * @member {Array.<module:model/ERPAdminCostDivisionRuleFixedRule>} FixedRules
   */
  exports.prototype['FixedRules'] = undefined;
  /**
   * @member {Array.<module:model/ERPAdminCostDivisionRuleLevel>} Levels
   */
  exports.prototype['Levels'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} DivisionMethodTypeID
   * @default 0
   */
  exports.prototype['DivisionMethodTypeID'] = 0;
  /**
   * @member {String} DivisionMethodAccountRange
   * @default ''
   */
  exports.prototype['DivisionMethodAccountRange'] = '';
  /**
   * @member {Integer} SourceTrackingLevelID
   * @default 0
   */
  exports.prototype['SourceTrackingLevelID'] = 0;
  /**
   * @member {Integer} TargetAccountNumber
   */
  exports.prototype['TargetAccountNumber'] = undefined;
  /**
   * @member {Date} ValidFromDate
   */
  exports.prototype['ValidFromDate'] = undefined;
  /**
   * @member {Date} ValidToDate
   */
  exports.prototype['ValidToDate'] = undefined;
  /**
   * @member {Integer} DivisionMethodIndicatorID
   */
  exports.prototype['DivisionMethodIndicatorID'] = undefined;
  /**
   * @member {Boolean} UsePreviousRule
   * @default false
   */
  exports.prototype['UsePreviousRule'] = false;
  /**
   * @member {Boolean} UseBudgetAndForecastData
   * @default false
   */
  exports.prototype['UseBudgetAndForecastData'] = false;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


